<template>
  <div>
    <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
      <div class="banner perBan">
        <img :src="banners.image" alt="">
        <div class="w1440">
          <div class="txt">
            <p class="fnt_52">
              {{ globalDataArray.siteTemplateLanguage.banner_welcome }}
              <template v-if="saitiAccessInfo.nickname">{{ saitiAccessInfo.nickname }}</template>
              <template v-else-if="saitiAccessInfo.username">{{ saitiAccessInfo.username }}</template>
            </p>
            <span class="fnt_18 mail" v-if="saitiAccessInfo.email">{{ saitiAccessInfo.email }}</span>
            <span class="fnt_18" v-else-if="saitiAccessInfo.phone">{{ saitiAccessInfo.phone }}</span>
          </div>
        </div>
      </div>

      <div class="personPage">
        <div class="cf w1440">
          <div class="personLeft">
            <personmenu />
          </div>

          <div class="personRight">
            <div class="page-header">
              <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.competition_hosting_history || '办赛历史' }}</div>
            </div>

            <div class="antDesignTable">
              <a-table
                row-key="id"
                :scroll="{ x: true }"
                :columns="columns"
                :data-source="list"
                :pagination="paginationOpt"
                :loading="loading"
                :class="['j-table-force-nowrap', 'compact-action-buttons']"
              >
                <template slot="tit" slot-scope="text, record">
                  <a-tooltip :title="text">
                    <router-link target="_blank" :to="'/competitionInfo?id='+record.parentId" class="compNameBtn">{{ text }}</router-link>
                  </a-tooltip>
                </template>
                <template slot="status" slot-scope="text, record">
                  <a-tag :color="record.status === '1' ? 'green' : 'orange'">
                    {{ text }}
                  </a-tag>
                </template>

                <template slot="mark" slot-scope="text">
                  <template v-if="text">
                    <a-tag
                      v-for="(tag, index) in Array.isArray(text) ? text : (typeof text === 'string' ? text.split(',') : [])"
                      :key="index"
                      color="blue"
                      style="margin-bottom: 4px"
                    >
                      {{ tag }}
                    </a-tag>
                  </template>
                </template>

                <template slot="checkStatus" slot-scope="text, record">
                  <div class="check-status-cell">
                    <a-tag :color="getCheckStatusColor(record.checkStatus)">
                      {{ text }}
                    </a-tag>
                    <a-tooltip :title="record.checkRemark || '...'">
                      <a-icon
                        v-if="record.checkStatus === '04' || record.checkStatus === '06'"
                        type="info-circle"
                        style="color: rgba(0,0,0,.45); margin-left: 4px;"
                      />
                    </a-tooltip>
                  </div>
                </template>

                <template slot="action" slot-scope="text, record">
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click.prevent>
                      {{ globalDataArray.siteTemplateLanguage.more || '更多' }}
                      <DownOutlined />
                    </a>
                    <template #overlay>
                      <a-menu>
                        <a-menu-item @click="handlePreviewDetail(record)">
                          <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.preview_detail || '详情预览' }}</a>
                        </a-menu-item>
                        <a-menu-item @click="handlePreviewList(record)">
                          <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.preview_list || '列表预览' }}</a>
                        </a-menu-item>
                        <a-menu-item v-if="hasChildCompetitions(record)" @click="handleShowChildList(record)">
                          <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.child_competition_list || '子赛项列表' }}</a>
                        </a-menu-item>
                        <a-menu-item v-if="record.checkStatus === '05' || record.checkStatus === '06'" @click="handleEdit(record)">
                          <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.edit || '编辑' }}</a>
                        </a-menu-item>
                        <a-menu-item v-if="record.checkStatus !== '02' && record.checkStatus !== '03'" @click="handleDelete(record)">
                          <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.delete || '删除' }}</a>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </template>

                <!--                <template slot="action" slot-scope="text, record">-->
                <!--                  <div class="antTableAction">-->
                <!--                    <span @click="handlePreviewDetail(record)" class="compEditBtn mr8">-->
                <!--                      {{ globalDataArray.siteTemplateLanguage.preview_detail || '详情预览' }}-->
                <!--                    </span>-->
                <!--                    <span @click="handlePreviewList(record)" class="compEditBtn mr8">-->
                <!--                      {{ globalDataArray.siteTemplateLanguage.preview_list || '列表预览' }}-->
                <!--                    </span>-->
                <!--                    <span-->
                <!--                      v-if="hasChildCompetitions(record)"-->
                <!--                      @click="handleShowChildList(record)" class="compEditBtn mr8"-->
                <!--                    >-->
                <!--                      {{ globalDataArray.siteTemplateLanguage.child_competition_list || '子赛项列表' }}-->
                <!--                    </span>-->
                <!--                    <span-->
                <!--                      v-if="record.checkStatus === '05' || record.checkStatus === '06'"-->
                <!--                      @click="handleEdit(record)" class="compEditBtn mr8"-->
                <!--                    >-->
                <!--                      {{ globalDataArray.siteTemplateLanguage.edit || '编辑' }}-->
                <!--                    </span>-->
                <!--                    <span-->
                <!--                      v-if="record.checkStatus !== '02' && record.checkStatus !== '03'"-->
                <!--                      @click="handleDelete(record)" class="compEditBtn mr8"-->
                <!--                    >-->
                <!--                      {{ globalDataArray.siteTemplateLanguage.delete || '删除' }}-->
                <!--                    </span>-->
                <!--                  </div>-->
                <!--                  <div class="antTableActionMore">-->
                <!--                    <template>-->
                <!--                      <a-dropdown>-->
                <!--                        <a class="ant-dropdown-link" @click.prevent>-->
                <!--                          更多-->
                <!--                          <DownOutlined />-->
                <!--                        </a>-->
                <!--                        <template #overlay>-->
                <!--                          <a-menu>-->
                <!--                            <a-menu-item @click="handlePreviewDetail(record)">-->
                <!--                              <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.preview_detail || '详情预览' }}</a>-->
                <!--                            </a-menu-item>-->
                <!--                            <a-menu-item @click="handlePreviewList(record)">-->
                <!--                              <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.preview_list || '列表预览' }}</a>-->
                <!--                            </a-menu-item>-->
                <!--                            <a-menu-item v-if="hasChildCompetitions(record)" @click="handleShowChildList(record)">-->
                <!--                              <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.child_competition_list || '子赛项列表' }}</a>-->
                <!--                            </a-menu-item>-->
                <!--                            <a-menu-item v-if="record.checkStatus === '05' || record.checkStatus === '06'" @click="handleEdit(record)">-->
                <!--                              <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.edit || '编辑' }}</a>-->
                <!--                            </a-menu-item>-->
                <!--                            <a-menu-item v-if="record.checkStatus !== '02' && record.checkStatus !== '03'" @click="handleDelete(record)">-->
                <!--                              <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.delete || '删除' }}</a>-->
                <!--                            </a-menu-item>-->
                <!--                          </a-menu>-->
                <!--                        </template>-->
                <!--                      </a-dropdown>-->
                <!--                    </template>-->
                <!--                  </div>-->
                <!--                </template>-->
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑表单弹窗 -->
    <a-modal
      v-if="!$refs.editForm?.isFullscreen"
      :visible="editForm.visible"
      :footer="null"
      :closable="false"
      @cancel="closeEditForm"
      :width="'80%'"
      :destroy-on-close="true"
      :mask-closable="false"
      :body-style="{ padding: 0 }"
    >
      <CreateCompetition
        :visible="editForm.visible"
        :edit-data="editForm.record"
        @submit="handleEditFormSubmit"
        @cancel="closeEditForm"
        @fullscreen-change="handleEditFormFullscreenChange"
        ref="editForm"
      />
    </a-modal>

    <!-- 列表预览弹窗 -->
    <a-modal
      v-if="previewListVisible"
      :visible="previewListVisible"
      :title="globalDataArray.siteTemplateLanguage.preview_list || '列表预览'"
      width="80%"
      @cancel="closePreviewList"
      :footer="null"
    >
      <!--      <competition-preview-list-->
      <!--        :competition-data="previewData"-->
      <!--        @edit="handleEdit"-->
      <!--        @delete="handleDelete"-->
      <!--        @preview="handlePreviewDetail"-->
      <!--      />-->
      <multi-condtion-info-new
        ref="imgDiv"
        :show-object="previewData"
        :from-query="fromQuery"
        @toSignFun="toSignFun"
        @addBrowserAndBookmark="toSignFun"
      />
    </a-modal>

    <!-- 子赛项列表弹窗 -->
    <div class="childListModal" v-if="childListVisible">
      <div class="pagePopMask pFull" @click="closeChildList"></div>
      <div class="pagePop pCenter">
        <div class="w pad60">
          <div class="tit fnt_32">{{ childListTitle }}</div>
          <div class="cont">
            <div class="antDesignTable">
              <a-table
                row-key="id"
                :scroll="{ x: true }"
                :columns="columns.filter(col => col.dataIndex !== 'parentCompetitionTitle')"
                :data-source="childList"
                :pagination="{ pageSize: 10, hideOnSinglePage: true }"
                :class="['j-table-force-nowrap', 'compact-action-buttons']"
                :loading="childListLoading"
              >
                <template slot="tit" slot-scope="text, record">
                  <a-tooltip :title="text">
                    <router-link target="_blank" :to="'/competitionInfo?id='+record.parentId" class="compNameBtn">{{ text }}</router-link>
                  </a-tooltip>
                </template>
                <template slot="status" slot-scope="text, record">
                  <a-tag :color="record.status === '1' ? 'green' : 'orange'">
                    {{ text }}
                  </a-tag>
                </template>
                <template slot="mark" slot-scope="text">
                  <template v-if="text">
                    <a-tag
                      v-for="(tag, index) in Array.isArray(text) ? text : (typeof text === 'string' ? text.split(',') : [])"
                      :key="index"
                      color="blue"
                      style="margin-bottom: 4px"
                    >
                      {{ tag }}
                    </a-tag>
                  </template>
                </template>
                <template slot="checkStatus" slot-scope="text, record">
                  <div class="check-status-cell">
                    <a-tag :color="getCheckStatusColor(record.checkStatus)">
                      {{ text }}
                    </a-tag>
                    <a-tooltip :title="record.checkRemark || '...'">
                      <a-icon
                        v-if="record.checkStatus === '04' || record.checkStatus === '06'"
                        type="info-circle"
                        style="color: rgba(0,0,0,.45); margin-left: 4px;"
                      />
                    </a-tooltip>
                  </div>
                </template>
                <template slot="action" slot-scope="text, record">
                  <span @click="handlePreviewDetail(record)" class="compEditBtn mr8">
                    {{ globalDataArray.siteTemplateLanguage.preview_detail || '详情预览' }}
                  </span>
                  <span @click="handlePreviewList(record)" class="compEditBtn mr8">
                    {{ globalDataArray.siteTemplateLanguage.preview_list || '列表预览' }}
                  </span>
                  <span
                    v-if="record.checkStatus === '05' || record.checkStatus === '06'"
                    @click="handleChildEdit(record)" class="compEditBtn mr8"
                  >
                    {{ globalDataArray.siteTemplateLanguage.edit || '编辑' }}
                  </span>
                  <span
                    v-if="record.checkStatus !== '02' && record.checkStatus !== '03'"
                    @click="handleChildDelete(record)" class="compEditBtn mr8"
                  >
                    {{ globalDataArray.siteTemplateLanguage.delete || '删除' }}
                  </span>
                </template>
              </a-table>
            </div>
          </div>
          <div class="btnBox fnt_18">
            <div class="btn btn2" @click="closeChildList">{{ globalDataArray.siteTemplateLanguage.cancel || '关闭' }}</div>
          </div>
          <div class="close" @click="closeChildList"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdList } from '@/api/api'
import { addBrowserAndBookmark, getCompetitionHostingHistory, previewStInfo } from '@/api/saiti'
import { deleteDraft } from '@/api/person/person'
import Cookies from 'js-cookie'
// import moment from 'moment'
import MultiCondtionInfoNew from '@/views/saiti/components/MultiCondtionInfoNew.vue'
import { saveCompetition } from '@/api/more/more'
import { stringToDateTime } from '@/utils/util'

export default {
  name: 'CompetitionHostingHistory',
  components: {
    MultiCondtionInfoNew,
    CreateCompetition: () => import('@/components/createCompetition/createCompetition.vue')
  },
  data() {
    return {
      saitiAccessInfo: '',
      banners: {},
      list: [],
      loading: false,
      editForm: {
        visible: false,
        record: null
      },
      fromQuery: '',
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => {
            return (this.paginationOpt.current - 1) * this.paginationOpt.pageSize + index + 1
          }
        },
        {
          title: '赛事名称',
          dataIndex: 'title',
          ellipsis: true,
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'tit' }
        },
        {
          title: '报名团队数',
          dataIndex: 'teams',
          width: 120,
          align: 'center',
          customRender: (text) => text || 0
        },
        {
          title: '奖金',
          dataIndex: 'bonus',
          width: 120,
          align: 'center',
          customRender: (text) => text || '-'
        },
        {
          title: '审核状态',
          dataIndex: 'checkStatus_dictText',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'checkStatus' }
        },
        {
          title: '发布状态',
          dataIndex: 'status_dictText',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        // {
        //   title: '共建方Logo',
        //   dataIndex: 'organizersLogo',
        //   width: 200,
        //   align: 'center',
        //   customRender: (text) => {
        //     if (!text) return '-'
        //     return text.split(',').map((logo, index) => {
        //       if (!logo) return null
        //       return <img
        //         key={index}
        //         src={logo}
        //         style='height: 30px; margin: 0 5px; object-fit: contain;'
        //         alt='共建方Logo'
        //       />
        //     }).filter(Boolean) // 过滤掉空值
        //   }
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          // width: 250,
          fixed: 'right',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      paginationOpt: {
        current: 1,
        total: 0,
        pageSize: 10,
        hideOnSinglePage: true,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        onChange: (current, size) => {
          this.paginationOpt.current = current
          this.paginationOpt.pageSize = size
          this.loadData()
        },
        onShowSizeChange: (current, size) => {
          this.paginationOpt.current = 1
          this.paginationOpt.pageSize = size
          this.loadData()
        }
      },
      previewData: null,
      previewListVisible: false,
      childList: [],
      childListVisible: false,
      childListTitle: '',
      currentParentId: null,
      childListLoading: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getAdList()
      this.tableHeader()
      if (Cookies.get('saiti_access_info')) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
      this.loadData()
    },
    tableHeader() {
      const that = this
      that.columns[0].title = that.globalDataArray.siteTemplateLanguage.person_table_number
      that.columns[1].title = that.globalDataArray.siteTemplateLanguage.competition_name
      that.columns[2].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_competition_teams
      that.columns[3].title = that.globalDataArray.siteTemplateLanguage.competition_bonus
      that.columns[4].title = that.globalDataArray.siteTemplateLanguage.review_status
      that.columns[5].title = that.globalDataArray.siteTemplateLanguage.publish_status
      that.columns[6].title = that.globalDataArray.siteTemplateLanguage.create_time
      that.columns[7].title = that.globalDataArray.siteTemplateLanguage.person_table_controls
    },
    handleFullscreenChange(isFullscreen) {
      // 可以在这里处理全屏状态变化
      console.log('Fullscreen changed:', isFullscreen)
    },
    loadData() {
      this.loading = true
      const params = `page=${this.paginationOpt.current}&pageSize=${this.paginationOpt.pageSize}`
      getCompetitionHostingHistory(params)
        .then(res => {
          if (res.success) {
            // 确保records是数组
            const records = res.result.records || []

            // 处理数据格式化（mark、organizers等字段）
            records.forEach(record => {
              this.processCompetitionItem([record])
            })

            this.list = records
            this.paginationOpt.total = res.result.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    processCompetitionItem(component) {
      component.forEach(item => {
        if (item.mark) {
          item.mark = item.mark.split(/[,，]/).filter(item => item.trim())
        }
        if (item.organizersLogo) {
          item.organizersLogo = item.organizersLogo.split(/[,，]/).filter(item => item.trim())
        }
        if (item.organizers) {
          item.organizers = item.organizers.split(/[,，]/).filter(item => item.trim())
        }
        if (item.endUtcTime) {
          const localEndtimeStr = new Date(item.endUtcTime).getTime()
          item.localEndtime = stringToDateTime(localEndtimeStr)
          item.localEndtimeStr = localEndtimeStr
        }
        item.ccompetitions?.forEach(res => {
          res.localEndtimeStr = new Date(res.endUtcTime).getTime()
          if (res.mark) {
            res.mark = res.mark.split(/[,，]/).filter(item => item.trim())
          }
          if (res.organizersLogo) {
            res.organizersLogo = res.organizersLogo.split(/[,，]/).filter(item => item.trim())
          }
          if (res.organizers) {
            res.organizers = res.organizers.split(/[,，]/).filter(item => item.trim())
          }

          // 子赛项的字典文本现在由后端处理，无需前端手动设置
        })
      })
    },
    getAdList() {
      getAdList('alias=person_banner').then(res => {
        if (res.success) {
          this.banners = res.result[0]
        }
      })
    },
    getCheckStatusColor(status) {
      const colorMap = {
        '01': '#d9d9d9', // 草稿
        '02': 'orange', // 待审核
        '03': 'green', // 审核通过
        '04': 'red', // 审核未通过
        '05': 'blue', // 已申报
        '06': 'red', // 退回
        '07': 'green', // 申报通过
        '08': 'orange'
      }
      return colorMap[status] || 'default'
    },
    getCurrentLanguage() {
      // 从Cookie或globalDataArray获取当前语言
      const cookieLang = Cookies.get('DEFAULT_LANG')
      console.log('Cookie中的语言:', cookieLang)
      console.log('globalDataArray中的语言:', this.globalDataArray?.currentLanguage)

      if (cookieLang) {
        console.log('使用Cookie语言:', cookieLang)
        return cookieLang
      }

      const fallbackLang = this.globalDataArray?.currentLanguage || 'zh_CN'
      console.log('使用fallback语言:', fallbackLang)
      return fallbackLang
    },
    async handleEdit(record) {
      this.editForm.record = record
      this.editForm.visible = true

      // 等待表单组件完成初始化
      await this.$nextTick()

      // 获取当前系统语言
      const currentLanguage = this.getCurrentLanguage()
      console.log('编辑时获取数据的语言:', currentLanguage)

      // 根据系统语言获取对应语言的数据
      const params = `id=${record.parentId}&language=${currentLanguage}`
      try {
        const res = await previewStInfo(params)
        if (res.success && res.result) {
          // 将数据传递给新的单语言表单组件
          this.$refs.editForm.setEditData(res.result)
        }
      } catch (error) {
        console.error('Error fetching competition details:', error)
        this.$message.error('加载失败')
      }
    },
    handleDelete(record) {
      this.$confirm({
        title: this.globalDataArray.siteTemplateLanguage.confirm_delete || '确认删除',
        content: this.globalDataArray.siteTemplateLanguage.delete_draft_confirm || '是否确认删除此草稿？删除后不可恢复',
        okText: this.globalDataArray.siteTemplateLanguage.confirm || '确认',
        cancelText: this.globalDataArray.siteTemplateLanguage.cancel || '取消',
        onOk: () => {
          deleteDraft(record.id).then(res => {
            if (res.success) {
              this.$message.success(this.globalDataArray.siteTemplateLanguage.delete_success || '删除成功')
              this.loadData()
            } else {
              this.$message.error(res.message || this.globalDataArray.siteTemplateLanguage.delete_failed || '删除失败')
            }
          })
        }
      })
    },
    closeEditForm() {
      this.editForm.visible = false
      this.editForm.record = null
    },
    handleEditFormSubmit(formDataArray) {
      this.loading = true
      // 如果是编辑子赛项，也设置子赛项列表的加载状态
      if (this.childListVisible) {
        this.childListLoading = true
      }

      // 保存当前操作的子赛项所属的父赛项ID
      const parentIdToRefresh = this.currentParentId

      saveCompetition(formDataArray)
        .then(res => {
          if (res.success) {
            this.$message.success(res.result)
            this.closeEditForm()

            // 刷新整个列表数据，并在完成后刷新子赛项列表
            const params = `page=${this.paginationOpt.current}&pageSize=${this.paginationOpt.pageSize}`
            getCompetitionHostingHistory(params)
              .then(listRes => {
                if (listRes.success) {
                  console.log('编辑后重新加载数据成功')

                  // 确保records是数组
                  const records = listRes.result.records || []

                  // 处理数据格式化（mark、organizers、时间等字段）
                  records.forEach(record => {
                    this.processCompetitionItem([record])
                  })

                  this.list = records
                  this.paginationOpt.total = listRes.result.total

                  // 加载完成后再刷新子赛项列表
                  if (this.childListVisible && parentIdToRefresh) {
                    const updatedParent = this.list.find(item => item.id === parentIdToRefresh)
                    if (updatedParent) {
                      // 使用统一的方法更新子赛项列表，确保数据格式化正确
                      this.updateChildListFromParent(updatedParent, true)
                    } else {
                      this.closeChildList()
                    }
                  }
                }
              })
              .finally(() => {
                // 清除临时存储的父赛项ID
                this.currentParentId = null
                this.loading = false
                this.childListLoading = false
              })
          } else {
            this.$message.error(res.message || '提交失败')
            this.loading = false
            this.childListLoading = false
          }
        })
        .catch(error => {
          console.error('保存失败:', error)
          this.$message.error('系统错误,请稍后重试')
          this.loading = false
          this.childListLoading = false
        })
    },
    async handlePreviewDetail(record) {
      // 跳转到预览详情页面
      const id = record.parentCompetitionId || record.parentId
      const previewUrl = `/previewinfo?id=${id}`
      window.open(previewUrl)
    },

    async handlePreviewList(record) {
      // 如果是父赛项
      if (!record.parentCompetitionId) {
        this.previewData = record
      }
      // 如果是子赛项，需要在列表中查找父赛项
      else {
        const parentCompetition = this.list.find(item => item.id === record.parentCompetitionId)
        if (parentCompetition) {
          this.previewData = {
            ...parentCompetition,
            ccompetitions: [record] // 只显示当前子赛项
          }
        }
      }

      // 处理mark数据，确保是数组格式
      if (this.previewData) {
        // 处理父赛项的mark
        if (typeof this.previewData.mark === 'string' && this.previewData.mark) {
          // 同时处理中英文逗号
          this.previewData.mark = this.previewData.mark.split(/[,，]/).filter(item => item.trim())
        }

        // 处理子赛项的mark
        if (this.previewData.ccompetitions && this.previewData.ccompetitions.length > 0) {
          this.previewData.ccompetitions.forEach(item => {
            if (typeof item.mark === 'string' && item.mark) {
              // 同时处理中英文逗号
              item.mark = item.mark.split(/[,，]/).filter(i => i.trim())
            }
          })
        }

        this.previewListVisible = true
      } else {
        this.$message.error('无法找到相关赛项信息')
      }
    },

    closePreviewList() {
      this.previewListVisible = false
      this.previewData = null
    },

    hasChildCompetitions(record) {
      // 检查并记录子赛项状态
      const hasChildren = !record.parentCompetitionId && record.ccompetitions && Array.isArray(record.ccompetitions) && record.ccompetitions.length > 0
      if (record.id && !record.parentCompetitionId) {
        const childCount = record.ccompetitions && Array.isArray(record.ccompetitions) ? record.ccompetitions.length : 0
        console.log(`Record ${record.id} has children: ${hasChildren}, child count: ${childCount}`)
      }
      return hasChildren
    },

    handleShowChildList(record) {
      console.log('handleShowChildList called with record id:', record.id)

      // 使用公共方法更新子赛项列表
      if (record && record.ccompetitions && Array.isArray(record.ccompetitions) && record.ccompetitions.length > 0) {
        // 设置加载状态
        this.childListLoading = true

        // 显示弹窗
        this.childListVisible = true

        // 确保在下一个渲染周期显示，并更新数据
        this.$nextTick(() => {
          console.log('Modal visible状态:', this.childListVisible)
          // 更新子赛项列表
          this.updateChildListFromParent(record)
          // 完成后关闭加载状态
          this.childListLoading = false
        })
      } else {
        console.log('No valid child competitions found', record)
        this.$message.info('没有子赛项')
      }
    },

    closeChildList() {
      console.log('关闭子赛项列表')
      this.childListVisible = false
      this.childListLoading = false

      // 确保在UI更新后再清空数据
      this.$nextTick(() => {
        this.childList = []
        this.childListTitle = ''
        this.currentParentId = null
      })
    },

    handleChildEdit(record) {
      // 存储当前子赛项所属的父赛项ID
      this.currentParentId = record.parentCompetitionId

      // 这里不需要设置childListLoading，因为我们打开编辑表单，而不是直接更新列表
      // 编辑表单提交时会设置相应的加载状态

      // 调用原有的编辑方法
      this.handleEdit(record)
    },

    handleChildDelete(record) {
      // 存储当前子赛项所属的父赛项ID
      this.currentParentId = record.parentCompetitionId

      this.$confirm({
        title: this.globalDataArray.siteTemplateLanguage.confirm_delete || '确认删除',
        content: this.globalDataArray.siteTemplateLanguage.delete_draft_confirm || '是否确认删除此草稿？删除后不可恢复',
        okText: this.globalDataArray.siteTemplateLanguage.confirm || '确认',
        cancelText: this.globalDataArray.siteTemplateLanguage.cancel || '取消',
        onOk: () => {
          // 设置子列表加载状态
          this.childListLoading = true

          deleteDraft(record.id).then(res => {
            if (res.success) {
              this.$message.success(this.globalDataArray.siteTemplateLanguage.delete_success || '删除成功')

              // 保存需要刷新的子赛项所属父赛项ID
              const parentIdToRefresh = this.currentParentId

              // 先清除子列表中的已删除项
              if (this.childListVisible) {
                this.childList = this.childList.filter(item => item.id !== record.id)
              }

              // 刷新整个列表数据，并在完成后刷新子赛项列表
              this.loading = true
              const params = `page=${this.paginationOpt.current}&pageSize=${this.paginationOpt.pageSize}`
              getCompetitionHostingHistory(params)
                .then(res => {
                  if (res.success) {
                    console.log('删除后重新加载数据成功')

                    // 确保records是数组
                    const records = res.result.records || []

                    // 处理数据格式化（mark、organizers、时间等字段）
                    records.forEach(record => {
                      this.processCompetitionItem([record])
                    })

                    this.list = records
                    this.paginationOpt.total = res.result.total

                    // 加载完成后再刷新子赛项列表
                    if (this.childListVisible && parentIdToRefresh) {
                      const updatedParent = this.list.find(item => item.id === parentIdToRefresh)
                      if (updatedParent) {
                        // 使用统一的方法更新子赛项列表，确保数据格式化正确
                        this.updateChildListFromParent(updatedParent, true)
                      } else {
                        this.closeChildList()
                      }
                    }
                  }
                })
                .finally(() => {
                  this.loading = false
                  this.childListLoading = false
                  // 清除临时存储的父赛项ID
                  this.currentParentId = null
                })
            } else {
              this.$message.error(res.message || this.globalDataArray.siteTemplateLanguage.delete_failed || '删除失败')
              this.childListLoading = false
            }
          }).catch(() => {
            this.childListLoading = false
          })
        }
      })
    },

    // 封装更新子赛项列表的方法
    updateChildListFromParent(parentRecord, skipLoadingControl = false) {
      if (!parentRecord || !parentRecord.ccompetitions) {
        console.log('父赛项无效或无子赛项，关闭子赛项列表')
        this.closeChildList()
        return
      }

      console.log('从父赛项更新子赛项列表，子赛项数量:', parentRecord.ccompetitions.length)

      // 只有在不跳过加载控制时才设置加载状态
      if (!skipLoadingControl) {
        this.childListLoading = true
      }

      // 复制子赛项数据（已经经过processCompetitionItem格式化处理）
      this.childList = [...parentRecord.ccompetitions]
      console.log('子赛项列表已更新，新数量:', this.childList.length)

      // 确保标题正确
      this.childListTitle = `${parentRecord.title || '父赛项'} - ${this.globalDataArray.siteTemplateLanguage.child_competition_list || '子赛项列表'}`

      // 只有在不跳过加载控制时才关闭加载状态
      if (!skipLoadingControl) {
        this.childListLoading = false
      }
    },

    // 在主列表更新后刷新子赛项列表
    refreshChildListAfterDataLoad(parentId) {
      if (!this.childListVisible || !parentId) {
        return
      }

      console.log('准备刷新子赛项列表，父赛项ID:', parentId)

      // 设置加载状态
      this.childListLoading = true

      // 直接从列表数据中找到父赛项
      const parentRecord = this.list.find(item => item.id === parentId)
      if (parentRecord) {
        this.updateChildListFromParent(parentRecord)
      } else {
        console.log('未找到父赛项，关闭子赛项列表')
        this.closeChildList()
      }

      // 操作完成，关闭加载状态
      this.childListLoading = false
    },
    async addBrowserAndBookmark(params, showObject) {
      const newObj = 'type=' + params.type + '&parentcompetitionId=' + params.parentcompetitionld + '&competitionId=' + params.competitionld
      const res = await addBrowserAndBookmark(newObj)
      if (res.success) {
        if (params.type === '3') {
          this.$message.success(this.globalDataArray.siteTemplateLanguage.unsubscribed_successfully)
        } else {
          this.$message.success(this.globalDataArray.siteTemplateLanguage.collection_successful)
        }
      }
    },
    toSignFun() {
      this.$message.warning(this.globalDataArray.siteTemplateLanguage.current_operable)
    },
    handleEditFormFullscreenChange(isFullscreen) {
      // 可以在这里处理全屏状态变化
      console.log('Edit form fullscreen changed:', isFullscreen)
    }
  },
  metaInfo() {
    return {
      title: this.globalDataArray.siteInfo.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.globalDataArray.siteInfo.description },
        { vmid: 'keywords', name: 'keywords', content: this.globalDataArray.siteInfo.keywords }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/person.css';

/* 修复Modal弹出时body被设置position: relative导致页头下移的问题 */
:global(body) {
  position: static !important;
  width: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.childListModal {
  .pagePop {
    max-height: 90vh;

    .cont {
      height: auto;
      max-height: 60vh;
      overflow-y: auto;
    }

    .antDesignTable {
      margin-top: 20px;
    }
  }

  .compEditBtn {
    color: #1281ff;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .mr8 {
    margin-right: 8px;
  }
}

.check-status-cell {
  display: flex;
  align-items: center;
}

/* 兼容移动端 */
@media only screen and (max-width: 768px) {
  .childListModal {
    .pagePop {
      width: 95%;

      .cont {
        max-height: 70vh;
      }

      .w.pad60 {
        padding: 40px 20px 30px 20px;
      }
    }
  }
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .tit {
    margin: 0;
  }

  .header-actions {
    .ant-btn {
      min-width: 100px;
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;

    .header-actions {
      width: 100%;

      .ant-btn {
        width: 100%;
      }
    }
  }
}
</style>
